import React from 'react';
import SectionSkeleton from './sectionskeleton';
import LazySection from 'components/lazySection';
import { useLocation } from 'react-router-dom';

const InvestorAbout = React.lazy(() => import('components/Investor/investorAbout'));
const InvestorBanner = React.lazy(() => import('components/Investor/investorBanner'));
const InvestorInvRelContact = React.lazy(() => import('components/Investor/investorInvRelContact'));
const InvestorSpecialList = React.lazy(() => import('components/Investor/investorSpecialList'));
const InvestorTabData = React.lazy(() => import('components/Investor/investorTabData'));

const InvestorsWith: React.FC = () => {
  const location = useLocation();
  const hash = location.hash;
  const corp = location.hash === "#corpgove-tab-pane";
  const esg = location.hash === "#esg-tab-pane";
  //console.log(location.hash)
  return (
    <>
        <InvestorBanner /> 
          {hash  ? (
            <>
                <InvestorAbout />
                <InvestorTabData />
                <InvestorSpecialList />
            </>
              ) : (
                <>
                    <LazySection fallback={<SectionSkeleton height={300} />}>
                      <InvestorAbout />
                    </LazySection>
                    <LazySection fallback={<SectionSkeleton height={350} />}>
                      <InvestorTabData />
                    </LazySection>
                      <LazySection fallback={<SectionSkeleton height={350} />}>
                        <InvestorSpecialList />
                      </LazySection>
              </>
            )}
              <LazySection fallback={<SectionSkeleton height={350} />}>
          <InvestorInvRelContact />
        </LazySection>
    </> 
  );
};

export default InvestorsWith;
